import { Col, Form, Radio, Row, Select, DatePicker, TimePicker } from 'antd';
import imgFiBox from '../../../assets/img/fi_box.svg';
import moment from 'moment';
const { RangePicker } = TimePicker;

const getCustomField = (field, index) => {
  const formProps = {
    key: field.key,
    name: field.key,
    label: field.name,
    rules: [
      {
        required: field.instance !== 'boolean' && !!field.required,
        message: `${field.name} дутуу байна!`,
      },
    ],
  };

  if (field.hasOwnProperty('enum') && field.instance === 'string') {
    const options = [...field.enum];
    return (
      <Row gutter={16} key={field.key}>
        <Col span={8}>
          <Form.Item {...formProps}>
            <Select showSearch mode={field.instance === 'array' ? 'multiple' : undefined}>
              {options.map((option) => {
                return (
                  <Select.Option key={option} value={option}>
                    {field.enumDictionary?.[option].name ?? option}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    );
  }

  if (field.hasOwnProperty('enum') && field.instance === 'radio') {
    const options = [...field.enum];
    return (
      <Form.Item {...formProps}>
        <Radio.Group style={{ width: '100%' }}>
          <Row gutter={[16, 16]}>
            {options.map((option) => {
              const item = field.enumDictionary[option];
              return (
                <Col key={item._id} span={12}>
                  <Radio value={item.code} className="rd__btn_locker">
                    <div className="rd__btn_locker__content">
                      <img src={item?.imageCover ?? imgFiBox} alt="fi" height={20} width={20} />
                      <div>
                        <div className="rd__btn_locker__title">{item.code}</div>
                        <div className="rd__btn_locker__description">{item.addressName}</div>
                      </div>
                    </div>
                  </Radio>
                </Col>
              );
            })}
          </Row>
        </Radio.Group>
      </Form.Item>
    );
  }
  switch (field.instance) {
    case 'timerange':
      return (
        <Row gutter={16} key={field.key}>
          <Col span={8}>
            <Form.Item {...formProps}>
              <RangePicker
                placeholder={['эхлэх', 'дуусах']}
                format="HH:mm"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
        </Row>
      );
    case 'time':
      return (
        <Row gutter={16} key={field.key}>
          <Col span={8}>
            <Form.Item {...formProps}>
              <TimePicker format="HH:mm" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>
      );
    case 'date':
      return (
        <Row gutter={16} key={field.key}>
          <Col span={8}>
            <Form.Item {...formProps}>
              <DatePicker
                style={{ width: '100%' }}
                format="YYYY/MM/DD"
                {...(field?.config ?? {})}
                disabledDate={(date) => {
                  return (
                    (moment(date).isAfter(
                      `${moment().format('YYYY-MM-DD 19:00:00')}`,
                      'millisecond'
                    ) &&
                      moment(date).isBefore(
                        `${moment().format('YYYY-MM-DD 23:59:59')}`,
                        'millisecond'
                      )) ||
                    date < moment().subtract(1, 'day')
                  );
                }}
              />
            </Form.Item>
          </Col>
        </Row>
      );

    default:
      return null;
  }
};

export { getCustomField };
